var React = require('react');

function Blob1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0083A0","d":"M71.156 37.202c3.426 9.123-1.425 22.25-9.657 27.501-8.233 5.206-19.892 2.537-29.77-4.272-9.88-6.808-17.979-17.666-15.575-25.41 2.447-7.787 15.396-12.37 27.679-12.148 12.282.223 23.94 5.251 27.323 14.329Z"}));
}

Blob1.defaultProps = {"width":"89","height":"89","fill":"none","viewBox":"0 0 89 89"};

module.exports = Blob1;

Blob1.default = Blob1;
